import { defineComponent as _defineComponent } from 'vue'
import Navigation from "../../../NavigationContainer.vue";
import SalesNoteLinkNavigation from "../../../KDPSalesNoteLinkNavigationContainer.vue";
import SalesNoteHeaderNavigation from "../../../KDPSalesNoteHeaderNavigationContainer.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();


const __returned__ = { Navigation, SalesNoteLinkNavigation, SalesNoteHeaderNavigation }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})